<template>
  <v-navigation-drawer
    v-if="isShown"
    fixed
    temporary
    right
    :width="width"
    stateless
    :value="isShown"
  >
    <v-container class="sidebar">
      <h3>{{ isNew ? `Add new ${sidebarName}` : `Edit ${sidebarName} details` }}</h3>
      <v-form
        ref="form"
        :value="isFormValid"
        lazy-validation
        @input="$emit('form-validity', $event)"
      >
        <TabForm
          :formElements="formElements"
          :readOnly="false"
          @max_column="processSidebarWidth"
          :planId="planId"
          :membershipId="membershipId"
          :exitId="exitId"
          :elements="elements"
          :defaultTabLabel="defaultTabLabel"
        />
      </v-form>
      <div class="btnsContainer">
        <div v-if="!isNew">
          <v-btn outlined color="error" :disabled="actionsDisabled" @click="$emit('delete')"
            >Delete</v-btn
          >
        </div>
        <div v-if="isSalary" class="ml-4">
          <v-btn
            depressed
            color="primary"
            :disabled="actionsDisabled"
            @click="$emit('recalculate')"
            class="ml-4"
            >Recalculate</v-btn
          >
        </div>

        <div v-if="isLeaver" class="calculateBtn">
          <v-btn
            outlined
            color="primary"
            class="mr-4 ml-4"
            :disabled="actionsDisabled"
            @click="$emit('calculationButtonClick', 'calculate')"
            >Calculate</v-btn
          >
          <v-btn
            v-if="showViewResults"
            class="mr-4"
            outlined
            color="primary"
            :disabled="actionsDisabled"
            @click="$emit('calculationButtonClick', 'viewResults')"
          >
            View results
          </v-btn>
          <v-btn
            v-if="showQuoteButton"
            outlined
            color="primary"
            :disabled="actionsDisabled"
            @click="$emit('calculationButtonClick', 'quote')"
            >Quote</v-btn
          >
        </div>
        <v-spacer></v-spacer>

        <div>
          <v-btn outlined color="primary" @click="$emit('cancel')" class="ml-4">Cancel</v-btn>
          <v-btn
            depressed
            color="primary"
            @click="onSave"
            class="ml-4"
            :disabled="actionsDisabled || !isFormValid"
            >Save</v-btn
          >
        </div>
      </div>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import TabForm from '@/components/TabForm.vue';

export default {
  name: 'Sidebar',
  components: { TabForm },
  props: {
    isShown: Boolean,
    isNew: Boolean,
    isSalary: { type: Boolean, default: false },
    isLeaver: { type: Boolean, default: false },
    formElements: Array,
    elements: Array,
    sidebarName: String,
    isFormValid: Boolean,
    membershipId: { type: Number },
    planId: { type: Number },
    exitId: { type: Number },
    defaultTabLabel: { type: String },
    showQuoteButton: {type: Boolean, default: false},
    showViewResults: {type: Boolean, default: false},
    actionsDisabled: { type: Boolean, default: false },
  },

  data: () => ({
    width: 475,
  }),

  methods: {
    onSave() {
      const isSidebarValid = this.$refs.form.validate();
      if (isSidebarValid) {
        this.$emit('save');
      }
    },

    processSidebarWidth(columnCount) {
      switch (columnCount) {
        case 1: {
          this.width = 475;
          break;
        }
        case 2: {
          this.width = 800;
          break;
        }
        case 3: {
          this.width = 950;
          break;
        }
        case 4: {
          this.width = 1100;
          break;
        }
        case 5: {
          this.width = 1300;
          break;
        }
        default: {
          if (columnCount > 5) {
            this.width = 1300;
          } else {
            this.width = 475;
          }
          break;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.sidebar {
  margin-bottom: 30px;
}

.sidebar h3 {
  margin-bottom: 20px;
}

.btnsContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.btnsContainer > div {
  display: inline-block;
}

.v-tabs {
  margin-bottom: 10px;

  .v-tabs-slider-wrapper {
    width: 0px !important;
    height: 0px !important;
  }

  .v-tab {
    border: 1px solid;
    border-radius: 30px;
    color: #4a1cd4 !important;
    height: 35px;
    margin-right: 10px;

    &.v-tab--active {
      color: white !important;
      background-color: #4a1cd4;
    }
  }
}
</style>
